import type { OnInit } from '@angular/core';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Hotjar } from './hotjar.service';
import { TrackingConsentStatus } from './interface';
import { TrackingConsent } from './tracking-consent.service';

@Component({
  selector: `fl-tracking-hotjar-init`,
  standalone: true,
  template: ` <ng-container></ng-container> `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HotjarComponent implements OnInit {
  constructor(
    private hotjar: Hotjar,
    private trackingConsent: TrackingConsent,
  ) {}

  async ngOnInit(): Promise<void> {
    const trackingConsentStatus =
      await this.trackingConsent.getThirdPartyStatus();
    if (trackingConsentStatus !== TrackingConsentStatus.AUTHORIZED) {
      return;
    }

    this.hotjar.insertScript();
  }
}
